import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ApiURl from "../Paths/Api";

const Home = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [loginType, setLoginType] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const slides = [
    {
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1920&q=80',
      title: 'Plan Seamless Meetings',
      description: 'Schedule and manage events effortlessly with our intuitive tools.',
    },
    {
      image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1920&q=80',
      title: 'Smart Attendance Tracking',
      description: 'Manage attendees with secure QR code scanning.',
    },
    {
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1920&q=80',
      title: 'Actionable Insights',
      description: 'Access real-time analytics and detailed event reports.',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Slider Navigation`, { slideIndex: index });
  };

  const handleAdminClick = () => {
    setLoginType('superadmin');
    setIsLogin(true);
    setError('');
    setPhone('');
    setPassword('');
    setIsNavbarOpen(false);
    console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Super Admin Login Modal Opened`, {});
  };

  const handleSupervisorClick = () => {
    setLoginType('supervisor');
    setIsLogin(true);
    setError('');
    setPhone('');
    setPassword('');
    setIsNavbarOpen(false);
    console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Supervisor Login Modal Opened`, {});
  };

  const handlePublicEventsClick = () => {
    navigate('/public-events');
    setIsNavbarOpen(false);
    console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Navigated to Public Events`, {});
  };

  const handleTermsAndConditions = () => {
    navigate('/term-condition');
    setIsNavbarOpen(false);
    console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Navigated to Terms and Conditions`, {});
  };

  const handleRefundPolicy = () => {
    navigate('/refund-policy');
    setIsNavbarOpen(false);
    console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Navigated to Refund Policy`, {});
  };

  const closeForm = () => {
    setIsLogin(false);
    setError('');
    setPhone('');
    setPassword('');
    console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Login Modal Closed`, {});
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Login Form Submitted`, { phone, loginType });

    if (!phone || !password) {
      setError('Please fill out all required fields');
      console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Validation Error`, { error: 'Missing phone or password' });
      return;
    }

    const loginData = { phone, password, loginType };
    console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Sending Login Request`, { loginData });

    try {
      const response = await fetch(`${ApiURl}/login.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginData),
      });

      const data = await response.json();
      console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Login API Response`, { data });
      console.log("User object received from backend:", data.user);

      if (data.success) {
        if (!data.user) {
          setError('Invalid response: User data missing');
          console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Invalid Response`, { error: 'User data missing' });
          return;
        }

        const role = data.user?.role?.toLowerCase() || '';
        const expectedRole = loginType.toLowerCase();
        console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Role Comparison`, { role, expectedRole });

        if (expectedRole === 'superadmin' && role !== 'superadmin') {
          setError(`Invalid ${loginType} credentials. Role received: ${role || 'none'}`);
          console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Role Mismatch Error`, { role, expectedRole });
          return;
        } else if (expectedRole === 'supervisor' && !['superadmin', 'supervisor'].includes(role)) {
          setError(`Invalid ${loginType} credentials. Role received: ${role || 'none'}`);
          console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Role Mismatch Error`, { role, expectedRole });
          return;
        }

        if (data.user.token && data.user.token_expires_at) {
          localStorage.setItem('token', data.user.token);
          localStorage.setItem('token_expires_at', data.user.token_expires_at);
          console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Token Stored`, {
            token: data.user.token.substring(0, 16) + '...',
            token_expires_at: data.user.token_expires_at,
          });
        } else {
          console.warn(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Token or Expiry Missing`, {
            token: !!data.user.token,
            token_expires_at: !!data.user.token_expires_at,
          });
        }
        localStorage.setItem('userId', data.user.id);
        localStorage.setItem('role', role);
        localStorage.setItem('phone', phone);
        localStorage.setItem('full_name', data.user.full_name || '');
        localStorage.setItem('company_name', data.user.company);
        localStorage.setItem('approval', data.user.approval || '');
        console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] User Data Stored in localStorage`, {
          userId: data.user.id,
          role,
        });

        if (role === 'superadmin' && expectedRole === 'superadmin') {
          navigate('/scan');
          console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Navigating to Super Admin Dashboard`, {});
        } else if (['superadmin', 'supervisor'].includes(role) && expectedRole === 'supervisor') {
          navigate('/supervisor');
          console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Navigating to Supervisor Dashboard`, {});
        }
        setIsLogin(false);
      } else {
        setError(data.message || 'Invalid credentials');
        console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Login Failed`, { message: data.message || 'Invalid credentials' });
      }
    } catch (err) {
      console.error('Login Error:', err);
      setError('Error occurred, please try again');
      console.log(`[${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}] Login API Error`, { error: err.message });
    }
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-gray-50 to-gray-200 font-sans">
      <style jsx>{`
        .slider-container {
          position: relative;
          height: 320px;
          overflow: hidden;
          border-radius: 0 0 2rem 2rem;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        }
        .slider-item {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transform: translateX(100%);
          transition: opacity 0.8s ease-in-out, transform 0.8s ease-in-out;
        }
        .slider-item.active {
          opacity: 1;
          transform: translateX(0);
          z-index: 10;
        }
        .slider-dots {
          position: absolute;
          bottom: 1.5rem;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 0.75rem;
          z-index: 20;
        }
        .slider-dot {
          width: 0.65rem;
          height: 0.65rem;
          background-color: rgba(255, 255, 255, 0.7);
          border-radius: 50%;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .slider-dot.active {
          background-color: white;
          transform: scale(1.4);
        }
        .slider-dot:hover {
          background-color: white;
          transform: scale(1.2);
        }
        .animate-slide-up {
          animation: slide-up 0.9s ease-out;
        }
        .animate-fade-in {
          animation: fade-in 0.7s ease-out;
        }
        .animate-scale-in {
          animation: scale-in 0.6s ease-out;
        }
        .animate-stagger {
          animation: stagger 0.6s ease-out forwards;
        }
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(25px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scale-in {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        @keyframes stagger {
          from { opacity: 0; transform: translateY(15px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .navbar-mobile {
          transform: translateX(100%);
          transition: transform 0.4s ease-in-out;
        }
        .navbar-mobile.open {
          transform: translateX(0);
        }
        .modal-glass {
          backdrop-filter: blur(12px);
          background: rgba(255, 255, 255, 0.95);
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        }
        .feature-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
        }
        .pulse {
          animation: pulse 2.5s infinite ease-in-out;
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.06); }
        }
        .footer-button {
          transition: all 0.3s ease;
        }
        .footer-button:hover {
          background-color: #e6fffa;
          color: #1a202c;
          transform: translateY(-2px);
        }
        @media (min-width: 640px) {
          .slider-container {
            height: 420px;
          }
        }
        @media (min-width: 1024px) {
          .slider-container {
            height: 520px;
          }
        }
      `}</style>

      {/* Navbar */}
      <nav className="bg-white text-gray-900 p-4 sticky top-0 z-50 shadow-lg">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center gap-3">
            <svg className="w-8 h-8 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <h1 className="text-2xl font-bold tracking-tight text-gray-900 animate-fade-in">Event Manager</h1>
          </div>
          <div className="hidden md:flex items-center gap-4">
            <button
              onClick={handlePublicEventsClick}
              className="px-5 py-2 bg-teal-100 text-teal-600 rounded-full font-medium hover:bg-teal-200 transition-all duration-300 hover:scale-105 shadow-sm"
            >
              Public Events
            </button>
            <button
              onClick={handleAdminClick}
              className="px-5 py-2 bg-teal-600 text-white rounded-full font-medium hover:bg-teal-700 transition-all duration-300 hover:scale-105 shadow-sm"
            >
              Super Admin
            </button>
            <button
              onClick={handleSupervisorClick}
              className="px-5 py-2 bg-teal-600 text-white rounded-full font-medium hover:bg-teal-700 transition-all duration-300 hover:scale-105 shadow-sm"
            >
              Supervisor
            </button>
          </div>
          <div className="md:hidden">
            <button
              onClick={() => setIsNavbarOpen(!isNavbarOpen)}
              className="p-2 rounded-full hover:bg-gray-100 focus:outline-none transition-all duration-300"
              aria-label="Toggle menu"
            >
              <svg className="w-6 h-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isNavbarOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'} />
              </svg>
            </button>
          </div>
        </div>
        <div className={`md:hidden fixed top-0 right-0 h-full w-64 bg-white shadow-2xl navbar-mobile ${isNavbarOpen ? 'open' : ''}`}>
          <div className="p-4 flex justify-end">
            <button
              onClick={() => setIsNavbarOpen(false)}
              className="p-2 rounded-full hover:bg-gray-100"
              aria-label="Close menu"
            >
              <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="flex flex-col p-4 gap-4">
            <button
              onClick={() => { handlePublicEventsClick(); }}
              className="px-5 py-2.5 text-left bg-teal-100 text-teal-600 rounded-lg font-medium hover:bg-teal-200 transition-all duration-300"
            >
              Public Events
            </button>
            <button
              onClick={() => { handleAdminClick(); }}
              className="px-5 py-2.5 text-left bg-teal-600 text-white rounded-lg font-medium hover:bg-teal-700 transition-all duration-300"
            >
              Super Admin
            </button>
            <button
              onClick={() => { handleSupervisorClick(); }}
              className="px-5 py-2.5 text-left bg-teal-600 text-white rounded-lg font-medium hover:bg-teal-700 transition-all duration-300"
            >
              Supervisor
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Slider */}
      <section className="relative">
        <div className="slider-container">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`slider-item ${index === currentSlide ? 'active' : ''}`}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-teal-900/70 to-gray-900/70 z-10" />
              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 flex flex-col items-center justify-center z-20 text-center px-4 animate-slide-up">
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 drop-shadow-lg">
                  {slide.title}
                </h2>
                <p className="text-base sm:text-lg lg:text-xl text-gray-100 max-w-3xl drop-shadow-md mb-6">
                  {slide.description}
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link
                    to="/main"
                    className="px-6 py-3 bg-teal-600 text-white rounded-full font-medium hover:bg-teal-700 transition-all duration-300 shadow-md hover:shadow-lg pulse"
                  >
                    Create Event
                  </Link>
                  <button
                    onClick={handlePublicEventsClick}
                    className="px-6 py-3 bg-white text-teal-600 rounded-full font-medium hover:bg-gray-100 transition-all duration-300 shadow-md hover:shadow-lg"
                  >
                    Public Events
                  </button>
                </div>
              </div>
            </div>
          ))}
          <div className="slider-dots">
            {slides.map((_, index) => (
              <div
                key={index}
                className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                role="button"
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="max-w-7xl mx-auto px-4 py-16">
        <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 text-center mb-12 animate-fade-in">
          Why Choose Event Manager?
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
              title: 'Effortless Scheduling',
              description: 'Plan events with an intuitive calendar and automated reminders.',
            },
            {
              icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
              title: 'Attendee Management',
              description: 'Invite and track participants with secure QR code scanning.',
            },
            {
              icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
              title: 'Real-Time Analytics',
              description: 'Monitor attendance and generate reports instantly.',
            },
          ].map((feature, index) => (
            <div
              key={index}
              className="feature-card bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 animate-stagger border border-gray-100"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={feature.icon} />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-gradient-to-r from-teal-600 to-teal-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 text-center animate-fade-in">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">Transform Your Events with Event Manager</h2>
          <p className="text-base lg:text-lg mb-8 max-w-3xl mx-auto">Join thousands of teams streamlining their events with our platform.</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/main"
              className="px-6 py-3 bg-white text-teal-600 rounded-full font-medium text-base hover:bg-gray-100 transition-all duration-300 shadow-md hover:shadow-lg"
            >
              Create Event
            </Link>
            <button
              onClick={handlePublicEventsClick}
              className="px-6 py-3 bg-teal-700 text-white rounded-full font-medium text-base hover:bg-teal-800 transition-all duration-300 shadow-md hover:shadow-lg"
            >
              Public Events
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative w-full py-6 text-center text-gray-600 text-sm z-10 bg-gray-50">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-center items-center gap-4">
          <a href="https://algo2botsinfotech.com/home/" className="hover:text-teal-600 transition-all duration-300">
            Powered by @ Algo2Bots Infotech • {new Date().getFullYear()}
          </a>
          <div className="flex gap-4">
            <button
              onClick={handleTermsAndConditions}
              className="footer-button px-3 py-1.5 text-gray-600 hover:text-teal-600 rounded-md text-sm font-medium transition-all duration-300"
              aria-label="Terms and Conditions"
            >
              Terms and Conditions
            </button>
            <button
              onClick={handleRefundPolicy}
              className="footer-button px-3 py-1.5 text-gray-600 hover:text-teal-600 rounded-md text-sm font-medium transition-all duration-300"
              aria-label="Refund Policy"
            >
              Refund Policy
            </button>
          </div>
        </div>
      </footer>

      {/* Login Modal */}
      {isLogin && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 animate-fade-in">
          <div className="modal-glass rounded-2xl shadow-2xl w-full max-w-md p-8 animate-scale-in">
            <button
              onClick={closeForm}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-all duration-300"
              aria-label="Close modal"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <h2 className="text-2xl font-bold text-gray-900 mb-2 text-center">
              {loginType === 'superadmin' ? 'Super Admin Login' : 'Supervisor Login'}
            </h2>
            <p className="text-gray-500 text-sm text-center mb-6">Access your dashboard securely</p>
            {error && (
              <div className="mb-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm animate-slide-up">
                {error}
              </div>
            )}
            <form onSubmit={handleLoginSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Enter phone number"
                  className="w-full px-4 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all duration-300 bg-white shadow-sm"
                  required
                  aria-required="true"
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                  Password <span className="text-red-500">*</span>
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  className="w-full px-4 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all duration-300 bg-white shadow-sm"
                  required
                  aria-required="true"
                />
              </div>
              <button
                type="submit"
                className="w-full py-2.5 bg-teal-600 text-white rounded-lg font-medium hover:bg-teal-700 transition-all duration-300 shadow-md hover:shadow-lg hover:scale-105"
              >
                Login
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;